export default __webpack_public_path__ + "static/custom-c6910f9b5cbfdaa41fa4d2cace6d5b0b.webp";